







import { Component, Prop, Vue } from 'vue-property-decorator';
import { Title } from '@/pages/profile/components/info/components/block/components/itemsblock';
import { IExaminationResult } from './types';

@Component({
  components: {
    Title,
  },
})
export default class ClassName extends Vue {
  @Prop({ type: Object, default: null })
  readonly result!: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/ExaminationResult/ExaminationResult.vue